import { Form, Modal } from 'react-bootstrap-5';
import React, { useState } from 'react';
import type { FormEvent } from 'react';
import { post, put } from 'helpers/api';
import ErrorAlert from '../../../project/components/new_listing_modal/error_alert';
import { Button } from 'components/ui/button';
import { getChildCompanyIdFromUrl } from '../shared';

type EditModalProps = {
  allowMultipleUsers?: boolean;
  id: string | number;
  isRole?: boolean;
  name?: string;
  onCloseModal: () => void;
  onSuccessfulFormSubmit: (result: any) => void;
};

export default function EditModal(props: EditModalProps) {
  const [inputName, setInputName] = useState<string>(props.name || '');
  const [inputIsRole, setInputIsRole] = useState<boolean>(props.isRole || false);
  const [inputAllowMultipleUsers, setInputAllowMultipleUsers] = useState<boolean>(props.allowMultipleUsers || false);
  const [errors, setErrors] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const canSubmitForm = inputName.length > 0;

  async function submitForm(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!canSubmitForm) {
      return;
    }

    setIsSubmitting(true);
    setErrors([]);

    const { fetchMethod, url } = fetchParams();
    try {
      const departmentArguments = {
        name: inputName,
        is_role: inputIsRole,
        allow_multiple_users: inputAllowMultipleUsers
      };
      const res = await fetchMethod(url, { company_department: departmentArguments });
      setIsSubmitting(false);
      if (res.id) {
        props.onSuccessfulFormSubmit(res);
      } else {
        setErrors(res);
      }
    } catch {
      setIsSubmitting(false);
      const uploadType = props.id === '' ? 'created' : 'updated';
      setErrors([`Department or Role could not be ${uploadType}. Please try again or contact support for help.`]);
    }
  }

  function fetchParams() {
    const childCompanyId = getChildCompanyIdFromUrl();
    const urlSuffix = childCompanyId ? `?child_company_id=${childCompanyId}` : '';

    if (props.id === '') {
      return { fetchMethod: post, url: `/company_departments${urlSuffix}` };
    }
    return { fetchMethod: put, url: `/company_departments/${props.id}${urlSuffix}` };
  }

  return (
    <Modal.Body className="p-5">
      <h5 className="text-center mt-0 mb-4">{props.id === '' ? 'Add a' : 'Edit'} Department or Role</h5>
      <ErrorAlert errorMessages={errors} hasErrors={errors.length > 0}/>
      <Form onSubmit={submitForm}>
        <Form.Group className="mb-3" controlId="department-name" >
          <Form.Label className="mb-1">Add Department or Role Name</Form.Label>
          <Form.Control
            autoFocus
            placeholder="Enter department or role name"
            value={inputName}
            onChange={e => setInputName(e.target.value)}
          />
        </Form.Group>
        
        { props.id === '' && (
          <Form.Group className="d-flex align-items-center gap-2">
            <Form.Check
              checked={inputIsRole}
              className="m-0"
              label="Role?"
              type="checkbox"
              onChange={e => setInputIsRole(e.target.checked)}
            />
          </Form.Group>
        )}

        <Form.Group className="d-flex align-items-center gap-2 mt-2">
          <Form.Check
            checked={inputAllowMultipleUsers}
            className="m-0"
            label="Allow multiple users?"
            type="checkbox"
            onChange={e => setInputAllowMultipleUsers(e.target.checked)}
          />
        </Form.Group>
        
        <div className="mt-5 d-flex gap-3 justify-content-end">
          <Button disabled={isSubmitting} type="button" variant="ghost" onClick={props.onCloseModal}>Cancel</Button>
          <Button disabled={!canSubmitForm || isSubmitting} type="submit">
            {props.id === '' ? 'Add' : 'Update'} Department or Role
          </Button>
        </div>
      </Form>
    </Modal.Body>
  );
}